import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { ICluster } from '~/types/cluster'

import TableVariation from '~/components/TableVariation'

export type Props = number

const ClusterVariationCellRenderer = ({ value }: ICellRendererParams<ICluster, Props>): ReactElement => {
  if (!value) return <div />

  return (
    <div className="cluster-variation-cell-renderer">
      <TableVariation value={value} withArrow={false} />
    </div>
  )
}

export default ClusterVariationCellRenderer
